import { Injectable } from '@angular/core';
import { concatLatestFrom } from '@ngrx/effects';
import { Observable, Subject, combineLatest } from 'rxjs';
import { filter, map, switchMap } from 'rxjs/operators';
import { AuthStore, InstallationDetailsStore, RemoteDiagnosticsGuardStatus } from '@store';
import { UIService } from '../../shared/services';

@Injectable({
  providedIn: 'root',
})
export class RemoteDiagnosticsService {
  private _scrollToTop$: Subject<void> = new Subject();

  scrollToTopValue$: Observable<number> = this._scrollToTop$.pipe(
    concatLatestFrom(() => this.uiService.isMobileView$),
    map(([_emission, isMobile]) => (isMobile ? 100 : 0))
  );

  constructor(
    private installationDetailsStore: InstallationDetailsStore,
    private authStore: AuthStore,
    private uiService: UIService
  ) {}

  getRemoteDiagnosticsAccessAndConnectionStatus(): Observable<RemoteDiagnosticsGuardStatus> {
    return this.installationDetailsStore.gatewaySerial$.pipe(
      switchMap((gatewaySerial) => {
        return combineLatest([
          this.installationDetailsStore.getGatewayStatus(gatewaySerial),
          this.authStore.hasAccessToDiagnostics$.pipe(
            filter((status) => status.isStoreReady),
            map((status) => status.hasAccessToDiagnostics)
          ),
        ]).pipe(
          map(([gatewayStatus, hasAccessToDiagnostics]) => {
            return {
              isDiagnosticsSessionRunning: gatewayStatus.remoteDiagnostic,
              hasAccessToDiagnostics,
            };
          })
        );
      })
    );
  }

  scrollToTop(): void {
    this._scrollToTop$.next();
  }
}
